module.exports = __webpack_public_path__ + "static/media/loading18.cc96a102.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading18.png
// module id = 203
// module chunks = 0